import type { RxJsonSchema } from 'rxdb';
import type { PreviousTaskComments } from './previousTaskComments.types';

export const previousTaskCommentsSchema: RxJsonSchema<PreviousTaskComments> = {
  type: 'object',
  version: 2,
  description: 'describes previous task comments',
  primaryKey: 'pkUuid',
  properties: {
    pkUuid: { type: 'string', maxLength: 36 },
    pkTaskWiseAuditComments: { type: ['number', 'null'] },
    fkAssetInspectionTask: { type: ['number', 'null'] },
    inspectorId: { type: ['number', 'null'] },
    fkClerk: { type: ['number', 'null'] },
    clerkId: { type: ['number', 'null'] },
    inspectorRoleId: { type: ['number', 'null'] },
    comment: { type: ['string', 'null'] },
    dateCreated: { type: 'string', maxLength: 36 },
    dateModified: { type: ['string', 'null'] },
    createdBy: { type: ['string', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    attentionFlag: { type: ['boolean', 'null'] },
  },
  indexes: ['dateCreated'],
};
